import _ from 'lodash';

const getCarrierFullName = (flightItinerary) => {
  if (
    !flightItinerary ||
    !flightItinerary.flightSegments ||
    flightItinerary.flightSegments.length === 0
  )
    return null;

  const { flightSegments } = flightItinerary;

  if (!flightSegments[0] || !flightSegments[0].flights || flightSegments[0].flights.length === 0)
    return null;

  const carrierFullNames = _.uniq(_.map(_.flatMap(flightSegments, 'flights'), 'carrierFullName'));

  return carrierFullNames.join(', ');
};

export default getCarrierFullName;
